import { useState } from 'react';
import { FaFile } from 'react-icons/fa6';
import { PeekLink } from '../../components/PeekLink';
import { ID } from '../../components/ID';

interface PageChipsProps {
  pageIds: string[];
}

const CAP_THRESHOLD = 12;

export function PageChips({ pageIds }: PageChipsProps) {
  const [expanded, setExpanded] = useState(false);
  const capped = !expanded && pageIds.length > CAP_THRESHOLD;

  if (pageIds.length === 0) {
    return null;
  }

  return (
    <div>
      <div className={'flex flex-wrap gap-1 ' + (capped ? 'max-h-[88px] overflow-hidden' : '')}>
        {pageIds.map((pageId) => (
          <PeekLink
            key={pageId}
            type="page"
            id={pageId}
            className="inline-flex items-center gap-1 rounded bg-indigo-50 px-1.5 py-0.5 text-xs text-indigo-700 hover:bg-indigo-100 dark:bg-indigo-950/40 dark:text-indigo-300 dark:hover:bg-indigo-900/40"
          >
            <FaFile className="size-3" />
            <ID id={pageId} />
          </PeekLink>
        ))}
      </div>
      {pageIds.length > CAP_THRESHOLD && (
        <button
          type="button"
          onClick={() => setExpanded((v) => !v)}
          className="mt-1 text-[11px] text-indigo-600 hover:underline dark:text-indigo-300"
        >
          {expanded ? 'Show fewer' : `Show all (${pageIds.length})`}
        </button>
      )}
    </div>
  );
}
